import { Injectable } from '@angular/core';
import { EntityState, EntityStore, StoreConfig } from '@datorama/akita';
import { AuctionItem } from './models/auction-item.model';

export interface AuctionState extends EntityState<AuctionItem> {}

@Injectable({ providedIn: 'root' })
@StoreConfig({ name: 'auction', idKey: 'Id', cache: { ttl: 5000 } })
export class AuctionStore extends EntityStore<AuctionState> {

  constructor() {
    super();
  }

}

